function loadScript(url) {
  document.addEventListener('DOMContentLoaded', function (event) {
    let script = document.createElement('script')
    script.src = url
    document.head.appendChild(script)
  })
}
function loadStyleSheet(url) {
  document.addEventListener('DOMContentLoaded', function (event) {
    let styleSheet = document.createElement('link')
    styleSheet.rel = 'stylesheet'
    styleSheet.href = url
    document.head.appendChild(styleSheet)
  })
}

function loadAccessbeWidget() {
  var s = document.createElement('script')
  var h = document.querySelector('head') || document.body
  s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'
  s.async = true
  s.onload = function () {
    acsbJS.init({
      statementLink: '',
      footerHtml: '',
      hideMobile: false,
      hideTrigger: false,
      disableBgProcess: false,
      language: 'en',
      position: 'left',
      leadColor: '#000000',
      triggerColor: '#000000',
      triggerRadius: '50%',
      triggerPositionX: 'left',
      triggerPositionY: 'top',
      triggerIcon: 'people',
      triggerSize: 'small',
      triggerOffsetX: 10,
      triggerOffsetY: 10,
      mobile: {
        triggerSize: 'small',
        triggerPositionX: 'left',
        triggerPositionY: 'bottom',
        triggerOffsetX: 10,
        triggerOffsetY: 10,
        triggerRadius: '50%',
      },
    })
  }
  h.appendChild(s)
}

const modules = {
  swiper: {
    default: '.swiper-wrapper',
    init: function () {
      loadStyleSheet('https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css')
      loadScript('https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js')
    },
  },
  fancybox: {
    default: '.gallery-with-fancybox-wrapper',
    init: function () {
      loadStyleSheet('https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css')
      loadScript('https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js')
    },
  },
  accessibe: {
    default: 'body',
    init: function () {
      $(window).on('load', function() {
        setTimeout(() => {
          loadAccessbeWidget()
        }, 1000);
      
      })
    },
  },
}

function initModules(obj, scope = document) {
  for (let key in obj) {
    let query = obj[key].default || key
    if (scope.querySelector(query)) {
      obj[key].init(query)
    }
  }
}

initModules(modules)
